/**
 * PBMSection - Output section for PBM (Pharmacy Benefit Manager) info (Drug only)
 *
 * Displays PBM name, contact info, and identifiers.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface PBMSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const PBMSection: React.FC<PBMSectionProps> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug PBM</span>
          <SectionTriggerScore subsectionKey="pbm" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.pbm">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="PBM Name"
              value={data?.pharmacy_benefit_manager_name}
              fieldId="pharmacy_benefit_manager_name"
            />
            <Field
              label="Phone Number"
              value={data?.pharmacy_benefit_manager_phone}
              fieldId="pharmacy_benefit_manager_phone"
            />
            <Field
              label="Fax Number"
              value={data?.pharmacy_benefit_manager_fax}
              fieldId="pharmacy_benefit_manager_fax"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
